import { render, staticRenderFns } from "./QuantityInCart.vue?vue&type=template&id=4b71234c"
import script from "./QuantityInCart.vue?vue&type=script&lang=ts"
export * from "./QuantityInCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports